module.exports = __webpack_public_path__ + "img/logo-white.77f2d56a.png";